/**
 * @description defines routes for the personnel mapping page
 */

import React from 'react';

import PersonnelMapping from '@seccon/pages/personnelMapping';

export default [
  {
    path: '/personnel/mapping',
    element: (
      <PersonnelMapping />
    )
  }
];
